import React, { lazy, useEffect, useState } from "react";
import "./App.scss";
import "./Rental-Customer/Styles/css/slick-carousel.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter, Route, Switch, withRouter } from "react-router-dom";
import { operatorRoute } from "Constant/RouteConstant/operatorConstant";
import {
  tourOperatorFaq,
  tourOperatorRoute,
} from "Constant/RouteConstant/TourOperatorConstant";
import OperatorLanding from "rental-operator/OperatorLanding";
import AddNewTicket from "Rental-admin/TicketManagement/AddNewTicket";
const OperatorRoutes = lazy(() => import("./OperatorRoute"));
const RentalAdminRoute = lazy(() => import("RentalAdminRoute"));
const CommonHeader = lazy(() => import("./CommonHeader"));
const ThankYou = lazy(() => import("./rental-operator/common-ui/ThankYou"));
const OperatorFaq = lazy(() => import("./rental-operator/Faq"));
const CancellationPolicy = lazy(() =>
  import("./rental-operator/CancellationPolicy")
);
const AddInventory = lazy(() =>
  import("./rental-operator/ListOfFleets/AddInventory")
);
const FinanceApprovals = lazy(() => import("./Rental-admin/FinanceApprovals"));
const TourOperatorRoute = lazy(() => import("TourOperatorRoute"));
const TourAdminRoute = lazy(() => import("./TourAdminRoute"));
const Notify = lazy(() => import("component/Toaster"));
const MaintanBikeToaster = lazy(() => import("component/MaintanBikeToaster"));
const RentalGuideIndex = lazy(() =>
  import("Onboarding-Guide/Rental-Guide/RentalGuideIndex")
);

function App(props) {
  const [appClass, setAppClass] = useState("");
  const location = window.location.pathname;
  let path = location.split("/");

  useEffect(() => {
    // console.log("path anand", path?.[1])
    // console.log("props", props)
    path?.[1] === operatorRoute ||
    path?.[1] === "admin" ||
    path?.[1] === "tour-admin" ||
    path?.[1] === tourOperatorRoute
      ? setAppClass("operator-journey")
      : path?.[1] == "tour-customer"
      ? setAppClass("tour-customer")
      : setAppClass("");
  }, [props?.location?.pathname?.split("/")[1]]);

  const lazyRetry = function (componentImport) {
    return new Promise((resolve, reject) => {
      // try to import the component
      componentImport()
        .then((component) => {
          resolve(component);
        })
        .catch((error) => {
          // TO DO
          reject(error); // there was an error
        });
    });
  };

  const ScrollToTop = lazy(() =>
    lazyRetry(() => import("Rental-Customer/ScrollToTop"))
  );
  return (
    // <React.Suspense fallback={<span></span>}>
    //   <ErrorBoundary>
    <div id="App" className={`App ${appClass}`}>
      {/* <BrowserRouter> */}
      <ScrollToTop>
        <CommonHeader />

        <MaintanBikeToaster />
        <Switch>
          <Route exact path="/" component={OperatorLanding} />
          <Route path="/thankyou" component={ThankYou} />
          <Route path="/partner-faq" component={OperatorFaq} />
          <Route path={tourOperatorFaq} component={OperatorFaq} />
          <Route path="/cancellation-policy" component={CancellationPolicy} />
          <Route path="/add-inventory" component={AddInventory} />

          <Route path="/request-page" component={Request} />

          <Route path="/finance-approval" component={FinanceApprovals} />

          <Route path="/tour-partner/" component={TourOperatorRoute} />
          <Route path="/partner/" component={OperatorRoutes} />
          <Route path="/admin/" component={RentalAdminRoute} />
          <Route path="/tour-admin/" component={TourAdminRoute} />
          <Route path="/guide/rental-tour-guide" component={RentalGuideIndex} />
          <Route
            path="/add-new-ticket"
            render={(props) => <AddNewTicket homepage {...props} />}
          />
        </Switch>
        <Notify />
      </ScrollToTop>
      {/* </BrowserRouter> */}
      <React.Suspense fallback={<span></span>}>
        {/* <Footer /> */}
      </React.Suspense>
    </div>
    //   </ErrorBoundary>
    // </React.Suspense>
  );
}

export default withRouter(App);
